import {
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  Input,
  ViewContainerRef,
  OnDestroy,
  OnChanges,
} from '@angular/core';
import { getClassName } from './components-register';

@Directive({
  selector: '[lcmsDynamicSearchComponent]',
})
export class DynamicSearchComponentDirective implements OnChanges, OnDestroy {
  @Input() cmpName: any;
  @Input() cmpData?: any;
  @Input() user_id?: any;
  @Input() showDetails?:boolean;
  componentRef: ComponentRef<any>;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {}

  ngOnChanges() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(
        getClassName(this.cmpName)
      );
    this.componentRef = this.viewContainerRef.createComponent(componentFactory);
    if (this.cmpData) this.componentRef.instance.cmpData = this.cmpData;
    if (this.user_id) this.componentRef.instance.user_id = this.user_id;
    if (this.showDetails) this.componentRef.instance.showDetails = this.showDetails;
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
}
